module.exports = __webpack_public_path__ + "545401e0c34a055f8ba175a2ff4953b8.png";